import {LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class NotificationWatcher extends BaseComponent {
	
	static get properties() {
		return {
			active: {type: Boolean},
			interval: {type: Number}			
		};
	}
	
	constructor() {
		super();
		
		this.active = true;
		this.interval = 60*1000;
		
		var notificationWatcher= this;
		setTimeout(function(){
			notificationWatcher.init();
		});
	}
	
	render() {	
		return html`			
			<slot></slot>		
		`;
	}
	
	init() {
		var notificationWatcher = this;
		
		var notifcationBadge = ElementUtil.create({
			tag: 'span',
			trustedInnerHTML: true,
			innerHTML: '<vaadin-icon icon="vaadin:bell-o"></vaadin-icon>',
			listeners: {
				click: function() {
					actionShowNotifications();
				}
			}
		});
		
		notificationWatcher.append(notifcationBadge);
		
		notifcationBadge.classList.add('no-messages');
		
		notificationWatcher.checkUnread = function() {
			Service.getNotificationService().getNotificationCurrentUser({
				max: 100,
				status: 'A'
			}).then(function(results){
				if (results.totalNumber === 0) {
					notifcationBadge.innerHTML = '<vaadin-icon icon="vaadin:bell-o"></vaadin-icon>';
					notifcationBadge.classList.remove('unread');
					notifcationBadge.classList.add('no-messages');
				} else if (results.totalNumber < 100) {
					notifcationBadge.innerHTML = '<vaadin-icon icon="vaadin:bell"></vaadin-icon> ' + results.totalNumber;
					notifcationBadge.classList.remove('no-messages');
					notifcationBadge.classList.add('unread');
				} else if (results.totalNumber >= 100) {
					notifcationBadge.innerHTML = '<vaadin-icon icon="vaadin:bell"></vaadin-icon> 99+';
					notifcationBadge.classList.remove('no-messages');
					notifcationBadge.classList.add('unread');
				}
				
				if (!notificationWatcher.watchId) {					
					notificationWatcher.startWatch();
				}
				
			}).catch(function(){
				notificationWatcher.stopWatch();
				
				if (notificationWatcher.retries) {
					notificationWatcher.retries++;
				} else {
					notificationWatcher.retries = 1;
				}
				if (notificationWatcher.retries < 4) {
					//5 min wait
					window.DL.MessageUtil.showToastError("Unable to get unread messages. Retry in 5 minute.");
					setTimeout(notificationWatcher.checkUnread, 300*1000);
				} else {
					window.DL.MessageUtil.showToastError("Unable to get unread messages. <br>Check connection and refresh site to continue.");
				}
			});		
		};
		//first call
		notificationWatcher.checkUnread();
				
		if (notificationWatcher.active) {
			notificationWatcher.startWatch();
		}
		
		var actionShowNotifications = function() {
			var notificationWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Notifications',
				icon: 'vaadin:bell',
				scope: 'app',
				listeners: {
					ready: function() {
						
						notificationWin.show();
						
						var notificationGrid = ElementUtil.create({
							tag: 'dl-notification-grid',
							slot: 'primary',
							local: true,
							properties: {
								dialogScope: 'app'
							},
							listeners: {
								'update-status': function() {
									actionRefreshWatch();
								},
								delete: function() {
									actionRefreshWatch();
								},
								'delete-all': function() {
									actionRefreshWatch();
								}
							}
						});
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								notificationGrid
							]
						});
						
						notificationWin.addToContentElement(flexLayout);	
						
						var actionRefreshWatch = function() {
							notificationWatcher.stopWatch();
							notificationWatcher.checkUnread();
							notificationWatcher.startWatch();
						};
					}
				}
			});
		};
		
	}
	
	stopWatch() {
		var notificationWatcher = this;
		if (notificationWatcher.watchId) {
			clearInterval(notificationWatcher.watchId);
			notificationWatcher.watchId = null;
		}
	}
	
	startWatch(newInterval) {
		var notificationWatcher = this;
		notificationWatcher.stopWatch();
		
		newInterval = newInterval || notificationWatcher.interval;
		notificationWatcher.interval = newInterval;		
		notificationWatcher.watchId = setInterval(notificationWatcher.checkUnread, newInterval);		
	}
	
};
customElements.define('dl-notification-watcher', NotificationWatcher);